import React from 'react';
import { Reveal } from './Reveal';
import { useContent } from '../content/ContentProvider';
import '../styles/glass.css';

export const ApproachTimeline: React.FC = () => {
  const { approach } = useContent();

  return (
    <section id="approach">
      <div className="section-head">
        <div>
          <div className="eyebrow">{approach.eyebrow}</div>
          <h2
            className="display-h2"
            style={{ marginTop: 14 }}
            dangerouslySetInnerHTML={{ __html: approach.headingHtml }}
          />
        </div>
        <p className="small" style={{ maxWidth: 380 }}>
          {approach.intro}
        </p>
      </div>

      <div className="approach-wrap">
        <Reveal className="approach-intro glass">
          <div>
            <div className="eyebrow" style={{ marginBottom: 22 }}>
              {approach.focusEyebrow}
            </div>
            <p className="lead" dangerouslySetInnerHTML={{ __html: approach.focusQuoteHtml }} />
          </div>
          <div>
            {approach.focusChips.map((chip, i) => (
              <span
                key={chip}
                className="chip"
                style={i < approach.focusChips.length - 1 ? { marginRight: 8 } : undefined}
              >
                {chip}
              </span>
            ))}
          </div>
        </Reveal>

        <div className="approach-steps">
          {approach.steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 80} className="approach-step glass-soft">
              <div className="step-num">{s.n}</div>
              <div>
                <h4>{s.t}</h4>
                <p>{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
